(function ($, Drupal, drupalSettings) {
  'use strict';

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    // Ensure GSAP presence
    if (typeof window.gsap === 'undefined') {
      console.warn('[asi_doors] GSAP not loaded; library will not run.');
      return;
    }

    const gsap = window.gsap;
    if (window.ScrollTrigger) {
      gsap.registerPlugin(window.ScrollTrigger);
    }

    // Required markup:
    // <section class="animation-section">
    //   <canvas id="logo-canvas"></canvas>
    // </section>
    const container = document.querySelector('.animation-section');
    const canvas = document.getElementById('logo-canvas');
    if (!container || !canvas) {
      return;
    }

    const ctx = canvas.getContext('2d');

    // Settings from Drupal
    const settings =
      (window.drupalSettings &&
        window.drupalSettings.asiDoors &&
        window.drupalSettings.asiDoors.gsapLogo) ||
      {};

    const frameCount = parseInt(settings.frameCount || 150, 10);
    const framesBaseUrl =
      settings.framesBaseUrl || '/sites/default/files/gsap/frames2/frame';
    const framePad = parseInt(settings.framePad || 4, 10);
    const frameExt = settings.frameExt || '.jpg';
    const maxDpr = 2; // cap DPR for performance

    let dpr = 1;

    function frameUrl(index) {
      const n = String(index).padStart(framePad, '0');
      return framesBaseUrl + n + frameExt;
    }

    function setCanvasSize() {
      dpr = Math.min(window.devicePixelRatio || 1, maxDpr);

      // Use container box to size canvas
      const rect = container.getBoundingClientRect();
      const width = Math.max(1, Math.floor(rect.width));
      const height = Math.max(1, Math.floor(rect.height));

      // Style size in CSS pixels (visual size)
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';

      // Internal buffer size in device pixels
      canvas.width = Math.max(1, Math.floor(width * dpr));
      canvas.height = Math.max(1, Math.floor(height * dpr));

      // Draw in CSS pixel coordinates by setting transform
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
    }

    function drawFrameCover(img) {
      // Fit like background-size: cover using CSS pixel coordinates
      const cw = Math.max(1, canvas.clientWidth);
      const ch = Math.max(1, canvas.clientHeight);

      const iw = img.naturalWidth || img.width || 1;
      const ih = img.naturalHeight || img.height || 1;

      const scale = Math.max(cw / iw, ch / ih);
      const dw = iw * scale;
      const dh = ih * scale;
      const dx = (cw - dw) / 2;
      const dy = (ch - dh) / 2;

      ctx.clearRect(0, 0, cw, ch);
      ctx.drawImage(img, dx, dy, dw, dh);
    }

    // Preload frames
    const images = new Array(frameCount);
    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.decoding = 'async';
      img.src = frameUrl(i + 1);
      images[i] = img;
    }

    const imageSeq = { frame: 0 };

    function render() {
      const idx = imageSeq.frame | 0;
      const img = images[idx];
      if (!img || !img.complete) return;
      drawFrameCover(img);
    }

    // Initial sizing
    setCanvasSize();

    // Render first frame when ready
    if (images[0]) {
      images[0].addEventListener('load', render, { once: true });
    }

    // GSAP sequence
    gsap.to(imageSeq, {
      frame: frameCount - 1,
      snap: 'frame',
      ease: 'none',
      onUpdate: render,
      scrollTrigger: {
        trigger: container,
        start: settings.start || '0 65%',
        end: settings.end || '+=2000',
        scrub: true,
        pin: !!settings.pin
      }
    });

    // Handle resizes/orientation changes
    function handleResize() {
      setCanvasSize();
      render();
      if (window.ScrollTrigger) {
        window.ScrollTrigger.refresh();
      }
    }

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', () => {
      // Let layout settle
      setTimeout(handleResize, 0);
    });
  });
})(jQuery, Drupal, drupalSettings);
